<script>
import { mapState, mapActions } from 'vuex';
/* components */
import ModalCheckEmail from '@/components/modal/ModalCheckEmail';
import InputBlock from '@/components/InputBlock';
import Button from '@/components/Button';
/* tools */
import {} from '@/scripts/utils';
import { resetPassword } from '@/scripts/api/account';
import {
  initGoogleReCaptcha,
  processGoogleReCaptcha,
  checkEmailValid,
  setAsyncInputError,
  emitClick,
  checkValidAndEmitClick,
} from '@/scripts/methods';
import { email } from '@/scripts/watch';
import { isFormValid } from '@/scripts/computed';

export default {
  name: 'ResetPassword',
  components: {
    ModalCheckEmail,
    Button,
    InputBlock,
  },
  props: {},
  data() {
    return {
      defaultValues: null,
      defaultTypes: null,
      values: null,
      types: null,
      /*  */
      email: '',
      code: '',
      /*  */
      emailSent: false,
      /*  */
      emailError: null,
      validFlagId: null,
    };
  },
  watch: {
    email,
  },
  computed: {
    ...mapState(['user', 'showModalCheckEmail']),
    isPasswordsValid() {
      const { values } = this;
      const { _new, confirm } = values;
      const result = (_new || confirm) && _new === confirm;

      return result;
    },
    isFormValid,
  },
  created() {
    this.fields = [
      { id: '_new', name: 'New' },
      { id: 'confirm', name: 'Confirm New' },
    ];

    const defaultValues = {
      _new: '',
      confirm: '',
    };

    const defaultTypes = {
      _new: 'password',
      confirm: 'password',
    };

    this.defaultValues = { ...defaultValues };
    this.defaultTypes = { ...defaultTypes };
    this.values = { ...defaultValues };
    this.types = { ...defaultTypes };
  },
  mounted() {
    this.initGoogleReCaptcha().then(this.processGoogleReCaptcha);
  },
  methods: {
    ...mapActions({ toggleModalCheckEmail: 'toggleModalCheckEmail' }),
    onRecaptchaVerified(reCaptcha, id) {
      window.grecaptcha.reset(id);

      const { email } = this;
      const payload = { email, reCaptcha };

      resetPassword(payload).then(() => {
        this.emailSent = true;
        this.toggleModalCheckEmail(true);
      });
    },
    setPassword() {
      const { email, code: passwordResetCode, values } = this;
      const { _new: newPassword } = values;
      const payload = { email, passwordResetCode, newPassword };

      resetPassword(payload).then(() => {
        this.$router.push('/login');
      });
    },
    switchVisibility(id) {
      const { types } = this;
      const currentVal = types[id];
      const nextVal = currentVal === 'password' ? 'text' : 'password';

      this.$set(this.types, id, nextVal);
    },
    goBack() {
      this.values = this.defaultValues;
      this.types = this.defaultTypes;
      this.emailSent = false;
      this.email = '';
      this.code = '';
    },
    initGoogleReCaptcha,
    processGoogleReCaptcha,
    checkEmailValid,
    setAsyncInputError,
    emitClick,
    checkValidAndEmitClick,
  },
};
</script>

<template>
  <!-- changePassword -->
  <div class="signup">
    <div class="signup__content">
      <div class="signup__top">
        <!-- >back -->
        <router-link v-if="!emailSent" to="/login" class="signup__arrow">
          <img :src="require('@/assets/svg/arrow-left.svg')" />
        </router-link>

        <button v-else @click="goBack" class="signup__arrow">
          <img :src="require('@/assets/svg/arrow-left.svg')" />
        </button>
        <!-- <back -->
        <div class="signup__title">
          {{ !emailSent ? 'Reset Password' : 'Change Password' }}
        </div>
      </div>
      <div class="signup__middle">
        <div class="form">
          <!-- >email  -->
          <div v-show="!emailSent" class="form__row form__row--content">
            <!--  -->
            <div class="form__row">
              <InputBlock
                :error="emailError"
                :forceValue="email"
                @input="val => (email = val)"
                @enter="checkValidAndEmitClick('recaptcha-reset')"
                tabindex="1"
                type="text"
                class="error-relative"
              >
                <template #label>
                  Email
                </template>
              </InputBlock>
            </div>
            <!--  -->
            <div class="form__row form__row--btn">
              <Button
                ref="recaptcha-reset"
                :disabled="!isFormValid"
                class="btn"
                tabindex="1"
              >
                Send Code
              </Button>
            </div>
          </div>
          <!-- <email  -->

          <!-- // -->
          <div
            v-if="emailSent && !showModalCheckEmail"
            class="form__row form__row--content"
          >
            <!--  -->
            <div class="form__row">
              <InputBlock :forceValue="code" @input="val => (code = val)">
                <template #label>
                  Code
                </template>
              </InputBlock>
            </div>
            <!-- >map = fields -->
            <div v-for="{ id, name } in fields" :key="id" class="form__row">
              <InputBlock
                :type="types[id]"
                :forceValue="values[id]"
                @input="val => (values[id] = val)"
              >
                <template #label>
                  <span>{{ name }} Password </span>
                </template>
                <template #btnShow>
                  <div
                    :class="{
                      'btn-show': true,
                      active: types[id] === 'text',
                    }"
                    @click="switchVisibility(id)"
                  >
                    <img :src="require('@/assets/svg/idea.svg')" />
                    <img :src="require('@/assets/svg/idea-active.svg')" />
                  </div>
                </template>
              </InputBlock>
            </div>
            <!-- <map -->
            <!-- save -->
            <div class="form__row form__row--btn">
              <button
                @click="setPassword"
                :disabled="!isPasswordsValid"
                class="btn"
              >
                Change Password
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- checkValidAndEmitClick('recaptcha-reset') -->
    <ModalCheckEmail
      v-if="emailSent && showModalCheckEmail"
      :email="email"
      @retry="goBack"
      @close="toggleModalCheckEmail()"
    />
  </div>
</template>

<style scoped lang="scss">
@import '@/styles/variables.scss';
.signup {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-direction: column;
  width: 100%;
  min-height: 100vh;
  height: 100%;
  padding: 80px 20px 20px;

  &__content {
    max-width: 570px;
    width: 100%;
  }

  &__title {
    font-family: Poppins-Light;
    font-size: 36px;
    line-height: 51px;
    color: #ffffff;
  }

  &__top {
    display: flex;
    align-items: center;
    margin-bottom: 50px;
  }

  &__subtitle {
    font-family: Poppins-Light;
    font-size: 18px;
    line-height: 1.5;
    color: #38d5b8;
    margin-top: 15px;
  }

  &__arrow {
    padding: 0;
    outline: none;
    border: 0;
    background: transparent;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 20px;
    transition: all 0.2;
    cursor: pointer;

    img {
      width: 16px;
      height: 14px;
      display: flex;
    }

    &:hover {
      opacity: 0.7;
    }
  }
}

.form {
  width: 100%;

  &__row {
    width: 100%;

    & + & {
      margin-top: 30px;
    }

    &--content + &--content {
      margin-top: 0;
    }

    & + &--btn {
      margin-top: 50px;
    }

    &--btn {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;
      margin-top: 50px;
    }
  }
}

.btn-show {
  width: 12px;
  height: 16px;
  display: flex;
  transition: all 0.2s;
  cursor: pointer;

  &:hover {
    opacity: 0.5;
  }

  img {
    display: flex;
    width: 100%;
    height: 100%;
  }

  img:last-child {
    display: none;
  }

  &.active {
    img {
      &:last-child {
        display: flex;
      }

      &:first-child {
        display: none;
      }
    }
  }
}

.btn {
  height: 44px;
  border-radius: 17px;
  background-color: #ffc107;
  color: #0d0d0d;
  min-width: 170px;
  outline: none;
  padding: 5px 10px;
  font-family: Poppins-Medium;
  font-size: 14px;
  line-height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-decoration: none;
  border: 0;
  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    opacity: 0.5;
  }

  &:disabled {
    opacity: 0.5;
    pointer-events: none;
  }
}

@media (max-width: $mobile) {
  .signup {
    justify-content: flex-start;
    padding: 20px 15px 40px;
    min-height: 100%;

    &__title {
      font-size: 21px;
      line-height: 29px;
      flex-shrink: 0;
    }

    &__content {
      height: 100%;
      display: flex;
      flex-direction: column;
    }

    &__middle {
      display: flex;
      flex-grow: 1;
    }

    &__top {
      margin-bottom: 50px;
    }

    &__arrow {
      img {
        width: 19px;
        height: 16px;
      }
    }
  }

  .form {
    height: 100%;
    display: flex;
    flex-direction: column;
    flex-grow: 1;

    &__row {
      &--content {
        display: flex;
        flex-direction: column;
        flex-grow: 1;
        width: 100%;
      }

      & + &--btn {
        margin-top: 40px;
      }

      &--btn {
        justify-content: flex-end;
        flex-direction: column;
        flex-grow: 1;
        align-items: center;
      }
    }
  }

  .btn {
    width: 100%;
    max-width: 290px;
  }
}
</style>
